import { Children, ReactElement } from "react";
import { EnsureDataChildProps, EnsureDataProps } from "./EnsureData.types";

function WhenEmpty({ children }: EnsureDataChildProps) {
  return <>{children}</>;
}

function WithData({ children }: EnsureDataChildProps) {
  return <>{children}</>;
}

export function EnsureData<T>({ data, children }: EnsureDataProps<T>) {
  const isEmpty = data.length === 0;

  const childArray = Children.toArray(children) as ReactElement[];

  const emptyChild = childArray.find((child) => child.type === WhenEmpty);
  const dataChild = childArray.find((child) => child.type === WithData);

  return isEmpty ? (emptyChild ?? null) : (dataChild ?? null);
}

EnsureData.WhenEmpty = WhenEmpty;
EnsureData.WithData = WithData;
